import React from 'react';
import { PharmaceuticalForm, SignupWelcome } from '../components';
import { Footer, ImageTopBar } from '../../common/components';
import { PageModeEnum } from '../../common/contracts';

export default function PharmaceuticalSignupPage(): JSX.Element {
  return (
    <>
      <ImageTopBar />
      <SignupWelcome
        title="Que bom ter você aqui no Abraçar a Vida!"
        subtitle=""
        strongMessage=""
        description="Para continuar, por favor, preencha as informações abaixo:"
      />
      <PharmaceuticalForm mode={PageModeEnum.CREATE}/>
      <Footer />
    </>
  );
}
